module.exports = __webpack_public_path__ + "static/media/ProximaNova-SemiboldIt.76050cd0.ttf";